import { showToast } from "helpers/toastHelper";

/**
 * Error handler function for React Query.
 * Can be used to handle query and mutation errors globally.
 * @param {unknown} error - The error object or message.
 */
export const errorHandler = (error: unknown) => {
	console.error("Error occurred:", error);
	if (error instanceof Error) {
		showToast({
			message: `Error: ${error.message}`,
			status: "error",
			position: "top-right",
			autoClose: true,
			duration: 3000,
		});
	} else {
		showToast({
			message: "An unexpected error occurred.",
			status: "error",
			position: "top-right",
			autoClose: true,
			duration: 3000,
		});
	}
};

/**
 * Success handler function for React Query.
 * Can be used to handle successful mutations globally.
 * @param {unknown} data - The data returned by the successful mutation.
 * @param {string} [message] - Optional success message (default is "Operation completed successfully!").
 */
export const successHandler = (
	data: unknown,
	message = "Operation completed successfully!",
) => {
	console.log("Success:", data);
	showToast({
		message,
		status: "success",
		position: "top-right",
		autoClose: true,
		duration: 3000,
	});
};
